import { render, staticRenderFns } from "./RecoverCart.vue?vue&type=template&id=705a07cc&scoped=true&"
import script from "./RecoverCart.vue?vue&type=script&lang=js&"
export * from "./RecoverCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a07cc",
  null
  
)

export default component.exports